export const state = {
    permissao: {},
    permissoes: [],
    modalExcluirPermissao: false,
    modalCadastrarPermissao: false,
}

export default {}